import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Button } from '../ui/Button.tsx';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Uncaught error:', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen-dvh items-center justify-center p-6">
          <div className="max-w-md rounded-2xl border border-line bg-surface p-8 text-center shadow-md">
            <h1 className="text-xl font-bold text-fg">Something went wrong</h1>
            <p className="mt-2 text-sm text-fg-2">
              {this.state.error.message}
            </p>
            <Button
              variant="primary"
              className="mt-5"
              onClick={() => window.location.reload()}
            >
              Reload
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
